import { SxProps, Theme } from '@mui/material';

import { EnvironmentName } from '@/api/util/useGetEnv.util.ts';

const ENVIRONMENT_BANNER_COLOR_MAP: Record<
  Exclude<EnvironmentName, 'prod'>,
  {
    backgroundColor: string;
    borderColor: string;
    color: string;
  }
> = {
  dev: {
    backgroundColor: '#FD4245',
    borderColor: '#FD4245',
    color: '#FFFFFF',
  },
  preview: {
    backgroundColor: '#C76D08',
    borderColor: '#F68315',
    color: '#FFFFFF',
  },
};

export const TopBarStyles: SxProps<Theme> = {
  borderRadius: '50px',
  mb: 2,
  py: 2,
};

export const EnvironmentBannerStyles = (
  environmentName: Exclude<EnvironmentName, 'prod'>,
): SxProps<Theme> => ({
  alignItems: 'center',
  backgroundColor: ENVIRONMENT_BANNER_COLOR_MAP[environmentName].backgroundColor,
  border: '2px solid',
  borderColor: ENVIRONMENT_BANNER_COLOR_MAP[environmentName].borderColor,
  borderRadius: '8px',
  boxShadow: '0 8px 18px rgba(17, 17, 17, 0.24), inset 0 0 0 1px rgba(255, 255, 255, 0.18)',
  color: ENVIRONMENT_BANNER_COLOR_MAP[environmentName].color,
  display: 'flex',
  fontWeight: 700,
  gap: 2,
  mb: 2,
  minHeight: '48px',
  px: 4,
  py: 1,
  width: '100%',
});
